export const LockIcon = () => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.8337 9.76823V7.4349C16.8337 4.21323 14.222 1.60156 11.0003 1.60156C7.77867 1.60156 5.16699 4.21323 5.16699 7.4349V9.76823M11.0003 15.0182V17.3516M7.26699 22.6016H14.7337C16.6938 22.6016 17.6739 22.6016 18.4226 22.2201C19.0812 21.8845 19.6166 21.3491 19.9522 20.6905C20.3337 19.9418 20.3337 18.9617 20.3337 17.0016V15.3682C20.3337 13.408 20.3337 12.428 19.9522 11.6793C19.6166 11.0207 19.0812 10.4853 18.4226 10.1497C17.6739 9.76823 16.6938 9.76823 14.7337 9.76823H7.26699C5.30681 9.76823 4.32672 9.76823 3.57803 10.1497C2.91946 10.4853 2.38403 11.0207 2.04847 11.6793C1.66699 12.428 1.66699 13.408 1.66699 15.3682V17.0016C1.66699 18.9617 1.66699 19.9418 2.04847 20.6905C2.38403 21.3491 2.91946 21.8845 3.57803 22.2201C4.32672 22.6016 5.30681 22.6016 7.26699 22.6016Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
